/*
 This file was auto-generated from config/recipes/templates/bl_admin/constants.js.erb
 DO NOT directly edit this file.
*/

export const CONFIG = {
  "products": {
    "productTypes": [
      "virtual_service_fee",
      "digital",
      "external",
      "drop_ship",
      "drop_ship_edi",
      "favor",
      "group_gift_contribution",
      "inventory",
      "hello_baby_box",
      "generated_from_reg_item",
      "physical_gift_card",
      "universal",
      "virtual_bundle"
    ],
    "externalProductTypes": [
      "external",
      "generated_from_reg_item",
      "universal"
    ],
    "singleProductTypes": [
      "external",
      "generated_from_reg_item"
    ],
    "taxCategories": [
      {
        "name": "Antibacterial Soap Only",
        "code": "PH400826"
      },
      {
        "name": "Baby Oil",
        "code": "PI040594"
      },
      {
        "name": "Baby Supplies - Bedding",
        "code": "PI041073"
      },
      {
        "name": "Baby Supplies - Carriers",
        "code": "PI041078"
      },
      {
        "name": "Baby Supplies - Furniture & Accessories",
        "code": "PI041076"
      },
      {
        "name": "Baby Supplies - Grooming",
        "code": "PI041077"
      },
      {
        "name": "Baby Supplies - Safety Items",
        "code": "PI041075"
      },
      {
        "name": "Baby Supplies - Strollers",
        "code": "PI041079"
      },
      {
        "name": "Baby Supplies - Strollers and Car Seats sold as a Single Unit",
        "code": "PI041080"
      },
      {
        "name": "Baby Products",
        "code": "PI040597"
      },
      {
        "name": "Bath Products",
        "code": "PH400834"
      },
      {
        "name": "Baby Wipes",
        "code": "PH050532"
      },
      {
        "name": "Breast Feeding:  Breast Milk Bottles and Breast Milk Storage Bottles",
        "code": "PH403700"
      },
      {
        "name": "Books",
        "code": "PB100000"
      },
      {
        "name": "Breast Feeding: Breast Milk Storage Bags / Breast Cream (Lanolin) / Softcup Feeders / Finger Feeders / Haberman Feeders / Supplemental Nursing Systems / Periodontal Syringes",
        "code": "PH403699"
      },
      {
        "name": "Breast Pump",
        "code": "PH403698"
      },
      {
        "name": "Child Car Seats & Restraints",
        "code": "PC020000"
      },
      {
        "name": "Cleaning Products",
        "code": "PC010000"
      },
      {
        "name": "Cloth Diapers",
        "code": "PI041082"
      },
      {
        "name": "Cloth Nursing Pads (Washable)",
        "code": "PI041106"
      },
      {
        "name": "Clothing & related products (B2C) - General",
        "code": "PC040100"
      },
      {
        "name": "Clothing & related products (B2C) - Nursing Bras",
        "code": "PC041098"
      },
      {
        "name": "Clothing & related products (B2C) - Other",
        "code": "PC040600"
      },
      {
        "name": "Clothing And Related Products - Childrens Clothing (below age 11)",
        "code": "PC040501"
      },
      {
        "name": "Clothing And Related Products - Childrens Footwear (below age 11)",
        "code": "PC040503"
      },
      {
        "name": "Covers",
        "code": "PH402842"
      },
      {
        "name": "Crib Blankets",
        "code": "PI041074"
      },
      {
        "name": "Diapers - baby",
        "code": "PH401850"
      },
      {
        "name": "Diaper rash ointments without zinc",
        "code": "PI040601"
      },
      {
        "name": "Diaper rash ointments with zinc",
        "code": "PI040610"
      },
      {
        "name": "Digital goods: videos-streaming / electronic download",
        "code": "DV010200"
      },
      {
        "name": "Equipment: Humidifier / Dehumidifier",
        "code": "PH403683"
      },
      {
        "name": "Gift Certificates",
        "code": "PG050000"
      },
      {
        "name": "Infant Supplies - bibs",
        "code": "PI040600"
      },
      {
        "name": "Lotions - Non-Medicated (Without Sunscreen)",
        "code": "PH400994"
      },
      {
        "name": "Medical Service",
        "code": "SH020400"
      },
      {
        "name": "Health care products-durable medical equipment-home use with a prescription",
        "code": "PH050208"
      },
      {
        "name": "Non-Medicated Baby Powder",
        "code": "PI040578"
      },
      {
        "name": "Over-the-Counter medicinal products - First aid kits",
        "code": "PH050676"
      },
      {
        "name": "Packaging and Supplies",
        "code": "PA200522"
      },
      {
        "name": "Receiving Blankets",
        "code": "PC031114"
      },
      {
        "name": "Shampoos & Conditioners - Non-Medicated",
        "code": "PH401002"
      },
      {
        "name": "Skin Care Kits",
        "code": "PH401010"
      },
      {
        "name": "Sun Blocks And Sun Screens",
        "code": "PH401019"
      },
      {
        "name": "Sunglasses without prescription",
        "code": "PH050461"
      },
      {
        "name": "Tangible Personal Property",
        "code": "P0000000"
      },
      {
        "name": "Thermometer",
        "code": "PH403898"
      },
      {
        "name": "Thermometer - Disposable",
        "code": "PH400044"
      }
    ]
  },
  "productReportingCategories": [
    {
      "id": 119,
      "name": "Apparel - Baby Sleepwear"
    },
    {
      "id": 112,
      "name": "Apparel - Bandana Bibs"
    },
    {
      "id": 2,
      "name": "Apparel - Bodysuits"
    },
    {
      "id": 3,
      "name": "Apparel - Bottoms"
    },
    {
      "id": 4,
      "name": "Apparel - Costumes"
    },
    {
      "id": 7,
      "name": "Apparel - Dresses"
    },
    {
      "id": 113,
      "name": "Apparel - Eyewear"
    },
    {
      "id": 121,
      "name": "Apparel - Gowns"
    },
    {
      "id": 111,
      "name": "Apparel - Hats"
    },
    {
      "id": 110,
      "name": "Apparel - Headbands & Bows"
    },
    {
      "id": 117,
      "name": "Apparel - Maternity Apparel"
    },
    {
      "id": 122,
      "name": "Apparel - Maternity Intimates"
    },
    {
      "id": 116,
      "name": "Apparel - Misc. Accessories"
    },
    {
      "id": 114,
      "name": "Apparel - Mittens"
    },
    {
      "id": 5,
      "name": "Apparel - Outerwear"
    },
    {
      "id": 12,
      "name": "Apparel - Outfit Sets"
    },
    {
      "id": 11,
      "name": "Apparel - Robes"
    },
    {
      "id": 118,
      "name": "Apparel - Rompers"
    },
    {
      "id": 115,
      "name": "Apparel - Shoes & Booties"
    },
    {
      "id": 109,
      "name": "Apparel - Socks & Tights"
    },
    {
      "id": 13,
      "name": "Apparel - Swimwear"
    },
    {
      "id": 120,
      "name": "Apparel - Toddler Sleepwear"
    },
    {
      "id": 14,
      "name": "Apparel - Tops"
    },
    {
      "id": 15,
      "name": "Bags - Diaper Bags"
    },
    {
      "id": 16,
      "name": "Bags - Pumping Bags"
    },
    {
      "id": 17,
      "name": "Bags - Travel Bags"
    },
    {
      "id": 123,
      "name": "Bath - Bath Accessories & Safety"
    },
    {
      "id": 20,
      "name": "Bath - Towels"
    },
    {
      "id": 21,
      "name": "Bath - Tubs"
    },
    {
      "id": 22,
      "name": "Bath - Washcloths"
    },
    {
      "id": 124,
      "name": "Books - Board Books"
    },
    {
      "id": 125,
      "name": "Books - Book Sets"
    },
    {
      "id": 127,
      "name": "Books - Books for Parents"
    },
    {
      "id": 126,
      "name": "Books - Misc. Books"
    },
    {
      "id": 97,
      "name": "Books - Picture Books"
    },
    {
      "id": 24,
      "name": "Car Seats - Boosters"
    },
    {
      "id": 23,
      "name": "Car Seats - Car Seat Accessories"
    },
    {
      "id": 25,
      "name": "Car Seats - Convertible Car Seat"
    },
    {
      "id": 26,
      "name": "Car Seats - Infant Car Seat"
    },
    {
      "id": 27,
      "name": "Carriers - Soft Carriers"
    },
    {
      "id": 28,
      "name": "Carriers - Structured Carriers"
    },
    {
      "id": 36,
      "name": "Diapering & Potty - Changing Pads"
    },
    {
      "id": 31,
      "name": "Diapering & Potty - Cloth Diapers"
    },
    {
      "id": 34,
      "name": "Diapering & Potty - Diaper Creams"
    },
    {
      "id": 38,
      "name": "Diapering & Potty - Diaper Pail Accessories"
    },
    {
      "id": 37,
      "name": "Diapering & Potty - Diaper Pails"
    },
    {
      "id": 30,
      "name": "Diapering & Potty - Diapering Accessories"
    },
    {
      "id": 32,
      "name": "Diapering & Potty - Diapers"
    },
    {
      "id": 33,
      "name": "Diapering & Potty - Potty Training"
    },
    {
      "id": 35,
      "name": "Diapering & Potty - Wipes"
    },
    {
      "id": 50,
      "name": "Feeding - Baby Food Makers"
    },
    {
      "id": 49,
      "name": "Feeding - Bibs"
    },
    {
      "id": 43,
      "name": "Feeding - Bottle Accessories"
    },
    {
      "id": 132,
      "name": "Feeding - Bottle Warmers & Sterilizers"
    },
    {
      "id": 42,
      "name": "Feeding - Bottles"
    },
    {
      "id": 172,
      "name": "Feeding - Breast Feeding"
    },
    {
      "id": 131,
      "name": "Feeding - Breast Feeding Accessories"
    },
    {
      "id": 130,
      "name": "Feeding - Breast Pump Accessories"
    },
    {
      "id": 129,
      "name": "Feeding - Breast Pumps"
    },
    {
      "id": 39,
      "name": "Feeding - Burp Cloths"
    },
    {
      "id": 133,
      "name": "Feeding - Drinking Cups"
    },
    {
      "id": 46,
      "name": "Feeding - Formula Feeding"
    },
    {
      "id": 44,
      "name": "Feeding - Nursing Pillows"
    },
    {
      "id": 40,
      "name": "Feeding - Pacifiers"
    },
    {
      "id": 48,
      "name": "Feeding - Solid Feeding"
    },
    {
      "id": 54,
      "name": "Furniture - Book Shelves"
    },
    {
      "id": 58,
      "name": "Furniture - Chairs"
    },
    {
      "id": 55,
      "name": "Furniture - Changing Tables"
    },
    {
      "id": 57,
      "name": "Furniture - Cribs"
    },
    {
      "id": 56,
      "name": "Furniture - Dressers"
    },
    {
      "id": 78,
      "name": "Furniture - Mattresses"
    },
    {
      "id": 59,
      "name": "Furniture - Tables"
    },
    {
      "id": 108,
      "name": "Gift Cards - Gift Cards"
    },
    {
      "id": 60,
      "name": "Gifts & Keepsakes - Baby Milestone Markers"
    },
    {
      "id": 64,
      "name": "Gifts & Keepsakes - Frames"
    },
    {
      "id": 63,
      "name": "Gifts & Keepsakes - Jewelry"
    },
    {
      "id": 62,
      "name": "Gifts & Keepsakes - Momentos"
    },
    {
      "id": 61,
      "name": "Gifts & Keepsakes - Photo Books & Journals"
    },
    {
      "id": 173,
      "name": "HBB - HBB"
    },
    {
      "id": 135,
      "name": "Health & Safety - Baby Gates"
    },
    {
      "id": 66,
      "name": "Health & Safety - Baby Proofing"
    },
    {
      "id": 137,
      "name": "Health & Safety - Baby Vitamins & Supplements"
    },
    {
      "id": 65,
      "name": "Health & Safety - Cleaning & Laundry"
    },
    {
      "id": 68,
      "name": "Health & Safety - First Aid"
    },
    {
      "id": 69,
      "name": "Health & Safety - Grooming & Hygiene"
    },
    {
      "id": 75,
      "name": "Health & Safety - Hearing Protection"
    },
    {
      "id": 70,
      "name": "Health & Safety - Humidifiers, Air Purifiers & UV Sterilizers"
    },
    {
      "id": 138,
      "name": "Health & Safety - Oral Hygiene"
    },
    {
      "id": 67,
      "name": "Health & Safety - Skin & Hair Care"
    },
    {
      "id": 73,
      "name": "Health & Safety - Suncare"
    },
    {
      "id": 136,
      "name": "Health & Safety - Thermometers"
    },
    {
      "id": 140,
      "name": "High Chairs - Convertible High Chairs"
    },
    {
      "id": 142,
      "name": "High Chairs - High Chair Accessories"
    },
    {
      "id": 141,
      "name": "High Chairs - Portable High Chairs"
    },
    {
      "id": 47,
      "name": "High Chairs - Traditional High Chairs"
    },
    {
      "id": 144,
      "name": "Maternity - Belly Bands and Support"
    },
    {
      "id": 51,
      "name": "Maternity - Nursing Covers"
    },
    {
      "id": 145,
      "name": "Maternity - Postpartum Care"
    },
    {
      "id": 143,
      "name": "Maternity - Prenatal Pillows"
    },
    {
      "id": 146,
      "name": "Maternity - Prenatal Vitamins & Supplements"
    },
    {
      "id": 148,
      "name": "Monitors - Monitor Accessories"
    },
    {
      "id": 147,
      "name": "Monitors - Smart Monitors"
    },
    {
      "id": 72,
      "name": "Monitors - Standard Monitors"
    },
    {
      "id": 80,
      "name": "Nursery & Decor - Bassinets & Bedside Sleepers"
    },
    {
      "id": 81,
      "name": "Nursery & Decor - Lighting"
    },
    {
      "id": 79,
      "name": "Nursery & Decor - Loungers & Co-Sleepers"
    },
    {
      "id": 82,
      "name": "Nursery & Decor - Mobiles"
    },
    {
      "id": 83,
      "name": "Nursery & Decor - Rugs"
    },
    {
      "id": 84,
      "name": "Nursery & Decor - Soothers & Sound Machines"
    },
    {
      "id": 85,
      "name": "Nursery & Decor - Storage & Organization"
    },
    {
      "id": 86,
      "name": "Nursery & Decor - Wall Decor"
    },
    {
      "id": 77,
      "name": "Nursery & Decor - Window Coverings"
    },
    {
      "id": 174,
      "name": "Packaging - Packaging"
    },
    {
      "id": 93,
      "name": "Play & Activity - Activity Centers"
    },
    {
      "id": 88,
      "name": "Play & Activity - Bouncers"
    },
    {
      "id": 94,
      "name": "Play & Activity - Infant Seats"
    },
    {
      "id": 95,
      "name": "Play & Activity - Jumpers"
    },
    {
      "id": 92,
      "name": "Play & Activity - Play Gyms"
    },
    {
      "id": 96,
      "name": "Play & Activity - Play Mats"
    },
    {
      "id": 150,
      "name": "Play & Activity - Play Tables & Chairs"
    },
    {
      "id": 91,
      "name": "Play & Activity - Playards & Portable Beds"
    },
    {
      "id": 89,
      "name": "Play & Activity - Swings"
    },
    {
      "id": 90,
      "name": "Play & Activity - Walkers"
    },
    {
      "id": 101,
      "name": "Strollers - Double Strollers"
    },
    {
      "id": 151,
      "name": "Strollers - Jogging Strollers"
    },
    {
      "id": 102,
      "name": "Strollers - Single Strollers"
    },
    {
      "id": 99,
      "name": "Strollers - Stroller Accessories"
    },
    {
      "id": 152,
      "name": "Strollers - Stroller Frames & Caddies"
    },
    {
      "id": 100,
      "name": "Strollers - Travel Systems"
    },
    {
      "id": 153,
      "name": "Strollers - Umbrella / Travel Strollers"
    },
    {
      "id": 154,
      "name": "Strollers - Wagons & Bikes"
    },
    {
      "id": 105,
      "name": "Swaddles & Sleep Sacks - 2-in-1 Swaddles"
    },
    {
      "id": 103,
      "name": "Swaddles & Sleep Sacks - Swaddle Blankets"
    },
    {
      "id": 155,
      "name": "Swaddles & Sleep Sacks - Swaddle Transition"
    },
    {
      "id": 106,
      "name": "Swaddles & Sleep Sacks - Wearable Blankets"
    },
    {
      "id": 160,
      "name": "Textiles - Bassinet Sheets"
    },
    {
      "id": 159,
      "name": "Textiles - Bedding Sets"
    },
    {
      "id": 107,
      "name": "Textiles - Blankets & Quilts"
    },
    {
      "id": 158,
      "name": "Textiles - Changing Pad Covers"
    },
    {
      "id": 170,
      "name": "Textiles - Crib Sheets"
    },
    {
      "id": 164,
      "name": "Textiles - Loveys"
    },
    {
      "id": 162,
      "name": "Textiles - Mattress Pads and Liners"
    },
    {
      "id": 156,
      "name": "Textiles - Pillows"
    },
    {
      "id": 161,
      "name": "Textiles - Playard Sheets"
    },
    {
      "id": 163,
      "name": "Textiles - Security Blankets"
    },
    {
      "id": 157,
      "name": "Textiles - Toddler Bedding"
    },
    {
      "id": 169,
      "name": "Toys - Bath Toys"
    },
    {
      "id": 168,
      "name": "Toys - Car Seat & Stroller Toys"
    },
    {
      "id": 98,
      "name": "Toys - Early Stage Toys"
    },
    {
      "id": 167,
      "name": "Toys - Plush Toys"
    },
    {
      "id": 41,
      "name": "Toys - Teethers & Rattles"
    },
    {
      "id": 166,
      "name": "Toys - Toddler Toys"
    },
    {
      "id": 165,
      "name": "Toys - Toy Subscriptions"
    }
  ],
  "returns": {
    "returnReasonOther": "Other",
    "returnReasons": [
      "Too small",
      "Too large",
      "Bought by mistake",
      "Better price available",
      "Product damaged, but shipping box OK",
      "Item arrived too late",
      "Missing parts or accessories",
      "Product and shipping box both damaged",
      "Wrong item was sent",
      "Item defective or doesn't work",
      "Received extra item I didn't buy (no refund needed)",
      "Hello Baby Box order cancelled",
      "No longer needed",
      "Style not as expected",
      "Bought wrong size, style, or color",
      "Didn't approve purchase",
      "Inaccurate website description",
      "Already received gift",
      "Other"
    ],
    "returnTypeCredit": "credit",
    "returnTypeRefund": "refund",
    "returnTypes": [
      "credit",
      "refund"
    ]
  }
}
export const CONTENTFUL_SPACE_ID = '50gzycvace50'
export const PRODUCT_DIVISIONS = ["DIV_1","DIV_2","DIV_3","DIV_4","DIV_5","DIV_6","DIV_7","DIV_8","DIV_9","DIV_10"]
export const PRODUCT_OFFER_SOURCE_ADMIN = 'admin'
export const PRODUCT_TYPE_DIGITAL= 'digital'
export const PRODUCT_TYPE_DROP_SHIP = 'drop_ship'
export const PRODUCT_TYPE_DROP_SHIP_EDI = 'drop_ship_edi'
export const PRODUCT_TYPE_EXTERNAL = 'external'
export const PRODUCT_TYPE_FAVOR = 'favor'
export const PRODUCT_TYPE_GENERATED_FROM_REG_ITEM = 'generated_from_reg_item'
export const PRODUCT_TYPE_GROUP_GIFT_CONTRIBUTION = 'group_gift_contribution'
export const PRODUCT_TYPE_INVENTORY = 'inventory'
export const PRODUCT_TYPE_HELLO_BABY_BOX = 'hello_baby_box'
export const PRODUCT_TYPE_PHYSICAL_GIFT_CARD = 'physical_gift_card'
export const PRODUCT_TYPE_UNIVERSAL = 'universal'
export const PRODUCT_TYPE_VIRTUAL_BUNDLE = 'virtual_bundle'
export const PRODUCT_TYPE_VIRTUAL_SERVICE_FEE = 'virtual_service_fee'
export const SHOW_RETURN_MODAL_EVENT = 'returnModal.show'
export const CATALOG_CATEGORY_SORT_ORDERS = ["desc","asc"]
export const CATALOG_CATEGORY_SORT_TYPES = ["popular","reviews","rating","price","newest"]
export const BABYLIST_HEALTH_CATALOG = 'Babylist Health'
export const STORE_CATALOGS = ["Babylist", "Babylist Health", "Babylist Showroom"]
